import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import 'react-day-picker/dist/style.css';
import moment from 'moment-timezone';

type ContentType = { title: string; content: string[] };

interface CustomTableProps {
  tableHeader: string[];
  subHeader?: string[];
  renderTableItem: () => JSX.Element;
  type?: string;
  sortedHeader?: string[];
  dataList?: any[];
  setSortedList?: (sortedList: any[]) => void;
}

export type SortConfig = {
  key: string;
  direction: 'asc' | 'desc';
};

const CustomTable: React.FC<CustomTableProps> = ({
  tableHeader,
  subHeader,
  renderTableItem,
  type,
  sortedHeader,
  dataList,
  setSortedList,
}) => {
  const [sortConfig, setSortConfig] = useState<SortConfig | null>(null);

  const handleSort = (key: string) => {
    console.log('sort', key);
    setSortConfig((prev) => {
      if (prev?.key === key) {
        return { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
      }
      return { key, direction: 'asc' };
    });
  };

  const getSortedList = () => {
    if (dataList && setSortedList) {
      const sortedTemp = [...dataList].sort((a, b) => {
        if (!sortConfig) return 0;

        const { key, direction } = sortConfig;
        const valueA = a[key as keyof any];
        const valueB = b[key as keyof any];

        let compareResult = 0;

        if (
          moment(valueA, 'YYYY-MM-DD HH:mm:ss', true).isValid() &&
          moment(valueB, 'YYYY-MM-DD HH:mm:ss', true).isValid()
        ) {
          console.log('moment', key, valueA, valueB);

          compareResult = moment(valueA).isBefore(moment(valueB))
            ? -1
            : moment(valueA).isAfter(moment(valueB))
            ? 1
            : 0;
        } else if (!isNaN(Number(valueA)) && !isNaN(Number(valueB))) {
          console.log('number', key, valueA, valueB);

          compareResult = Number(valueA) - Number(valueB);
        } else {
          console.log('string', key, valueA, valueB);
          compareResult = String(valueA).localeCompare(String(valueB));
        }

        return direction === 'asc' ? compareResult : -compareResult;
      });
      setSortedList([...sortedTemp]);
      console.log('sortedTemp', sortedTemp);
    }
  };

  useEffect(() => {
    if (sortConfig) {
      console.log('sortedConfig', sortConfig);
      getSortedList();
    }
  }, [sortConfig]);

  const tableClassName =
    type === 'noneborder' ? 'nonborder' : type === 'radius' ? 'radiusTable' : 'normalTable';
  return (
    <Style>
      <table className={tableClassName}>
        <thead>
          <tr>
            {tableHeader.map((header, index) => {
              return (
                <th
                  key={index}
                  colSpan={header === '할인금액(B)' ? 2 : 1}
                  rowSpan={header === '할인금액(B)' ? 1 : 2}>
                  {header}
                  {sortedHeader && sortedHeader[index].length > 0 && (
                    <button
                      className={`sortButton ${
                        sortConfig && sortConfig.key === sortedHeader[index] && 'active'
                      }`}
                      onClick={() => handleSort(sortedHeader[index])}>
                      {sortConfig && sortConfig.key === sortedHeader[index]
                        ? sortConfig.direction === 'asc'
                          ? '↑'
                          : '↓'
                        : '↓'}
                    </button>
                  )}
                </th>
              );
            })}
          </tr>
          {subHeader && (
            <tr>
              {subHeader.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          )}
        </thead>
        <tbody>{renderTableItem()}</tbody>
      </table>
    </Style>
  );
};

export default CustomTable;

const Style = styled.div`
  table,
  td,
  th {
    border-collapse: collapse;
    border: 1px solid #eaecf0;
  }
  td,
  th {
    padding: 8px 12px;
  }
  table {
    width: 100%;
  }
  th {
    background: #f9fafb;
    color: #212329;
    white-space: pre;
  }
  td {
    color: #000;
    font-size: 14px;
  }

  .title {
    padding: 0;
    padding-top: 8px;
    .content {
      min-width: 130px;
      border-bottom: none;
    }
    .content:nth-child(1) {
      border-left: none;
    }
    .content:nth-child(2) {
      border-right: none;
    }
  }

  .radiusTable {
    border-collapse: collapse;
    border-radius: 5px;
    border-style: hidden;
    box-shadow: 0 0 0 1px #e3e3e3;

    button {
      padding: 7px 20px;
      background: none;
      border: 1px solid #d6d6d6;
      border-radius: 50px;
      font-size: 14px;
      font-weight: 400;
      color: #333;
    }
    thead th {
      background: #f7f7f7;
      border: none;
      border-bottom: 1px solid #e3e3e3;
      padding: 8px;
      font-weight: 600;
    }
    thead th:nth-child(1) {
      border-radius: 5px;
    }
    thead th:nth-child(5) {
      border-radius: 5px;
    }
    tbody td {
      padding: 14px;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }

  .nonborder {
    border-collapse: collapse;
    border-radius: 5px;
    border-style: hidden;
    box-shadow: 0 0 0 1px #e3e3e3;

    button {
      padding: 7px 20px;
      background: none;
      border: 1px solid #d6d6d6;
      border-radius: 50px;
      font-size: 14px;
      font-weight: 400;
      color: #333;
    }
    thead th {
      background: #f7f7f7;
      border: none;
      border-bottom: 1px solid #e3e3e3;
      font-weight: 600;
    }
    thead th:nth-child(1) {
      border-radius: 5px;
    }
    thead th:nth-child(5) {
      border-radius: 5px;
    }
    tbody td {
      padding: 18px 0;
      border: none;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }
  .sortButton {
    border: none;
    padding: none;
    margin-left: 4px;
    background: #cecece;
    color: #f7f7f7;
    font-weight: 600;
    border-radius: 3px;
    padding: 0 2px;
  }
  .sortButton.active {
    background: #40977f;
  }

  @media (max-width: 700px) {
    overflow-x: auto;
  }
`;
